import { Box } from "@mui/material";

/**
* Footer - Component that display a simple footer on page
* @component
*/
const Footer = () => {
    const currentYear = new Date().getFullYear().toString()
    return (
        <Box
            component="footer"
            className="tw-hidden tw-w-full tw-place-items-center tw-px-4 tw-py-3 tw-text-center tw-font-prometo tw-text-xs tw-text-slate-500 lg:tw-grid"
            sx={{ letterSpacing: "0.01em" }}
        >
            {`© ${currentYear} Copyright - Todos os direitos reservados.`}
        </Box>
    );
};

export default Footer;
